<template>
  <div class="grid grid-cols-12 gap-x-4 gap-y-1 p-4 items-end">
    <div class="col-span-9 text-right font-bold">Total</div>
    <div class="col-span-2 text-right font-bold">{{ totalAmount }} &euro;</div>
  </div>
</template>

<script>
export default {
  props: {
    lineItems: {
      type: Array,
      default: () => [],
    },
  },

  computed: {
    totalAmount() {
      return this.lineItems.reduce((sum, { amount }) => {
        const lineAmount = Number.parseFloat(amount);
        return Number.parseFloat(Number.parseFloat(sum + lineAmount).toFixed(2));
      }, 0);
    },
  },
};
</script>
